module.exports = __webpack_public_path__ + "img/grid.3f1d571e.svg";